import { QueryClient } from "@tanstack/react-query";
import { RETRY_CONFIG } from "./config";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: RETRY_CONFIG.DEFAULT.retry,
      retryDelay: RETRY_CONFIG.DEFAULT.retryDelay,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
